export default __webpack_public_path__ + "static/media/zip-icon.8855c022.png";